import { ref, computed } from "vue";

export function useBulkSearch() {
  const searchTerms = ref("");
  const previousSearchTermsCount = ref(0);
  const currentSearchTermsCount = computed(() => {
    return searchTerms.value.split("\n").filter((entry: string) => entry.trim() !== "").length;
  });

  function updatePreviousSearchTermCount() {
    previousSearchTermsCount.value = currentSearchTermsCount.value;
  }

  async function resetBulkSearch(): Promise<boolean> {
    searchTerms.value = "";
    previousSearchTermsCount.value = 0;
    return true;
  }
  return {
    searchTerms,
    previousSearchTermsCount,
    currentSearchTermsCount,
    updatePreviousSearchTermCount,
    resetBulkSearch,
  };
}
